import { render, staticRenderFns } from "./adm_recent.vue?vue&type=template&id=35c894b0&scoped=true&"
import script from "./adm_recent.vue?vue&type=script&lang=js&"
export * from "./adm_recent.vue?vue&type=script&lang=js&"
import style0 from "./adm_recent.vue?vue&type=style&index=0&id=35c894b0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35c894b0",
  null
  
)

export default component.exports